export default "__VITE_ASSET__DNWoi8Ek__"